module.exports = __webpack_public_path__ + "media/images/smart_phone/past_order_history/ic_Category-6ec0aaa01dd2ced3bce5ce8c20ff3083.png";